import { TrendingUp, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';

const DatenschutzPage = () => {
  return (
    <div className="min-h-screen bg-background">
      {/* Navigation */}
      <nav className="border-b border-border bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 sticky top-0 z-50">
        <div className="container mx-auto px-4 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <TrendingUp className="h-8 w-8 text-primary" />
            <span className="text-xl font-heading font-bold">TradeJourn<span className="text-primary">.ai</span></span>
          </Link>
          <Link to="/">
            <Button variant="ghost" size="sm">
              <ArrowLeft className="h-4 w-4 mr-2" />
              Zurück
            </Button>
          </Link>
        </div>
      </nav>

      {/* Content */}
      <div className="container mx-auto px-4 py-12 max-w-4xl">
        <h1 className="text-3xl md:text-4xl font-heading font-bold mb-2">Datenschutzerklärung</h1>
        <p className="text-muted-foreground mb-8">Stand: Januar 2026</p>

        <div className="prose prose-invert prose-zinc max-w-none space-y-8">
          <p className="text-muted-foreground leading-relaxed">
            Der Schutz Ihrer personenbezogenen Daten ist uns ein wichtiges Anliegen. Diese Datenschutzerklärung 
            informiert Sie darüber, welche Daten wir erheben, wie wir diese verwenden und welche Rechte Ihnen zustehen. 
            Wir verarbeiten Ihre Daten ausschließlich auf Grundlage der gesetzlichen Bestimmungen, insbesondere der 
            EU-Datenschutz-Grundverordnung (DSGVO), soweit anwendbar, sowie der geltenden Datenschutzgesetze der 
            Vereinigten Arabischen Emirate.
          </p>

          <section>
            <h2 className="text-xl font-bold text-white mb-4">1. Verantwortlicher</h2>
            <p className="text-muted-foreground">
              Verantwortlich für die Datenverarbeitung auf dieser Plattform:
            </p>
            <div className="bg-zinc-800/50 rounded-lg p-4 mt-4 text-sm">
              <p className="font-medium text-white">TradeJourn.ai</p>
              <p className="text-muted-foreground mt-2">
                Dubai, Vereinigte Arabische Emirate<br />
                E-Mail: support@tradejourn.ai<br />
                Webseite: www.tradejourn.ai
              </p>
            </div>
            <p className="text-muted-foreground mt-4">
              Bei Fragen zum Datenschutz erreichen Sie uns unter der oben genannten E-Mail-Adresse.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-4">2. Welche Daten wir erheben</h2>
            
            <h3 className="text-lg font-semibold text-white mt-6 mb-3">2.1 Kontodaten (bei Registrierung)</h3>
            <ul className="list-disc list-inside text-muted-foreground space-y-1">
              <li>E-Mail-Adresse</li>
              <li>Passwort (verschlüsselt gespeichert)</li>
              <li>Name</li>
              <li>Bevorzugte Sprache</li>
            </ul>

            <h3 className="text-lg font-semibold text-white mt-6 mb-3">2.2 Trading-Daten</h3>
            <p className="text-muted-foreground mb-2">Bei Nutzung unserer Trading-Journal-Funktionen erheben wir:</p>
            <ul className="list-disc list-inside text-muted-foreground space-y-1">
              <li>Handelsdaten (Einstiegs-/Ausstiegszeiten, Preise, Symbole)</li>
              <li>Gewinn- und Verlustberechnungen (PnL)</li>
              <li>Screenshots und Chart-Bilder (sofern hochgeladen)</li>
              <li>Notizen und Journal-Einträge</li>
              <li>Emotionale Selbsteinschätzungen (Stimmung)</li>
              <li>Strategie-Zuordnungen</li>
            </ul>

            <h3 className="text-lg font-semibold text-white mt-6 mb-3">2.3 Zahlungsdaten</h3>
            <p className="text-muted-foreground">
              Zahlungen werden über unseren Zahlungsdienstleister Stripe abgewickelt. Wir speichern keine 
              vollständigen Kreditkarten- oder Bankdaten. Gespeichert werden lediglich:
            </p>
            <ul className="list-disc list-inside text-muted-foreground space-y-1 mt-2">
              <li>Stripe-Kunden-ID</li>
              <li>Abonnement-Status und -Verlauf</li>
              <li>Zahlungsreferenzen</li>
            </ul>

            <h3 className="text-lg font-semibold text-white mt-6 mb-3">2.4 Technische Daten</h3>
            <p className="text-muted-foreground mb-2">Bei jedem Zugriff auf unsere Plattform werden automatisch erhoben:</p>
            <ul className="list-disc list-inside text-muted-foreground space-y-1">
              <li>IP-Adresse</li>
              <li>Datum und Uhrzeit des Zugriffs</li>
              <li>Browser-Typ und -Version</li>
              <li>Betriebssystem</li>
              <li>Gerätetyp</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-4">3. Zweck der Datenverarbeitung</h2>
            
            <h3 className="text-lg font-semibold text-white mt-6 mb-3">3.1 Vertragserfüllung</h3>
            <ul className="list-disc list-inside text-muted-foreground space-y-1">
              <li>Bereitstellung der Trading-Journal-Funktionen</li>
              <li>KI-gestützte Trade-Analyse und Coaching</li>
              <li>Erstellung von Analysen und Berichten</li>
              <li>Abwicklung von Zahlungen und Abonnements</li>
            </ul>

            <h3 className="text-lg font-semibold text-white mt-6 mb-3">3.2 Kommunikation</h3>
            <ul className="list-disc list-inside text-muted-foreground space-y-1">
              <li>Benachrichtigungen zu Ihrem Konto</li>
              <li>Support-Anfragen beantworten</li>
              <li>Wichtige Produkt-Updates mitteilen</li>
            </ul>

            <h3 className="text-lg font-semibold text-white mt-6 mb-3">3.3 Sicherheit</h3>
            <ul className="list-disc list-inside text-muted-foreground space-y-1">
              <li>Schutz vor unbefugtem Zugriff</li>
              <li>Erkennung und Verhinderung von Betrug</li>
              <li>Gewährleistung der Systemintegrität</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-4">4. Rechtsgrundlagen</h2>
            <p className="text-muted-foreground">Die Verarbeitung Ihrer Daten erfolgt auf Basis folgender Rechtsgrundlagen:</p>
            <ul className="list-disc list-inside text-muted-foreground space-y-2 mt-4">
              <li><strong className="text-white">Vertragserfüllung:</strong> Für die Bereitstellung unserer Dienste und die Erfüllung des Nutzungsvertrags.</li>
              <li><strong className="text-white">Einwilligung:</strong> Für optionale Funktionen wie Marketing-E-Mails.</li>
              <li><strong className="text-white">Berechtigtes Interesse:</strong> Für Sicherheitsmaßnahmen und Betrugsprävention.</li>
              <li><strong className="text-white">Gesetzliche Verpflichtung:</strong> Für steuerliche Aufbewahrungspflichten bei Zahlungsdaten.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-4">5. Datenweitergabe an Dritte</h2>
            <p className="text-muted-foreground mb-4">Wir geben Ihre Daten nur in folgenden Fällen an Dritte weiter:</p>
            
            <h3 className="text-lg font-semibold text-white mt-6 mb-3">5.1 Auftragsverarbeiter</h3>
            <ul className="list-disc list-inside text-muted-foreground space-y-1">
              <li><strong className="text-white">Stripe:</strong> Zahlungsabwicklung und Abonnementverwaltung</li>
              <li><strong className="text-white">MongoDB Atlas:</strong> Datenbank-Hosting</li>
              <li><strong className="text-white">Resend:</strong> E-Mail-Versand für Benachrichtigungen</li>
              <li><strong className="text-white">OpenAI:</strong> KI-gestützte Analysen (nur anonymisierte Daten)</li>
              <li><strong className="text-white">Google:</strong> OAuth-Authentifizierung (optional)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-4">6. Datensicherheit</h2>
            <p className="text-muted-foreground mb-4">
              Wir setzen technische und organisatorische Maßnahmen ein, um Ihre Daten zu schützen:
            </p>
            <ul className="list-disc list-inside text-muted-foreground space-y-2">
              <li><strong className="text-white">Verschlüsselung:</strong> Alle Datenübertragungen erfolgen über SSL/TLS-verschlüsselte Verbindungen.</li>
              <li><strong className="text-white">Passwort-Sicherheit:</strong> Passwörter werden mit bcrypt gehasht und niemals im Klartext gespeichert.</li>
              <li><strong className="text-white">Zugriffskontrolle:</strong> Strenge Zugriffsrichtlinien für unsere Systeme.</li>
              <li><strong className="text-white">Session-Sicherheit:</strong> JWT-basierte Authentifizierung mit begrenzter Gültigkeit.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-4">7. Cookies</h2>
            <p className="text-muted-foreground mb-4">
              Wir verwenden nur technisch notwendige Cookies für den Betrieb der Plattform:
            </p>
            <ul className="list-disc list-inside text-muted-foreground space-y-1">
              <li>Session-Cookies für die Anmeldung</li>
              <li>Sicherheits-Cookies</li>
              <li>Stripe-Zahlungscookies</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-4">8. Speicherdauer</h2>
            <p className="text-muted-foreground mb-4">
              Wir speichern Ihre Daten nur so lange, wie es für die jeweiligen Zwecke erforderlich ist:
            </p>
            <ul className="list-disc list-inside text-muted-foreground space-y-1">
              <li><strong className="text-white">Kontodaten:</strong> Bis zur Löschung Ihres Kontos</li>
              <li><strong className="text-white">Trading-Daten:</strong> Bis zur Löschung Ihres Kontos oder auf Ihren Wunsch früher</li>
              <li><strong className="text-white">Zahlungsdaten:</strong> 7 Jahre nach der letzten Transaktion (gesetzliche Aufbewahrungspflicht)</li>
              <li><strong className="text-white">Protokolldaten:</strong> 90 Tage</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-4">9. Ihre Rechte</h2>
            <p className="text-muted-foreground mb-4">Sie haben folgende Rechte bezüglich Ihrer personenbezogenen Daten:</p>
            <ul className="list-disc list-inside text-muted-foreground space-y-2">
              <li><strong className="text-white">Auskunftsrecht:</strong> Sie können jederzeit Auskunft darüber verlangen, welche Daten wir über Sie gespeichert haben.</li>
              <li><strong className="text-white">Recht auf Berichtigung:</strong> Sie können die Berichtigung unrichtiger Daten verlangen.</li>
              <li><strong className="text-white">Recht auf Löschung:</strong> Sie können die Löschung Ihrer Daten verlangen, sofern keine gesetzlichen Aufbewahrungspflichten bestehen.</li>
              <li><strong className="text-white">Recht auf Datenübertragbarkeit:</strong> Sie haben das Recht, Ihre Daten in einem gängigen Format zu erhalten.</li>
              <li><strong className="text-white">Widerspruchsrecht:</strong> Sie können der Verarbeitung Ihrer Daten jederzeit widersprechen.</li>
            </ul>
            <p className="text-muted-foreground mt-4">
              Zur Ausübung Ihrer Rechte kontaktieren Sie uns bitte unter: <a href="mailto:support@tradejourn.ai" className="text-primary hover:underline">support@tradejourn.ai</a>
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-4">10. Änderungen dieser Datenschutzerklärung</h2>
            <p className="text-muted-foreground">
              Wir behalten uns vor, diese Datenschutzerklärung bei Bedarf zu aktualisieren, um sie an geänderte 
              rechtliche Anforderungen oder Änderungen unserer Dienste anzupassen. Die aktuelle Version ist 
              stets auf unserer Webseite verfügbar. Bei wesentlichen Änderungen werden wir Sie per E-Mail 
              oder durch einen Hinweis auf der Plattform informieren.
            </p>
          </section>

          <section className="border-t border-zinc-800 pt-8 mt-8">
            <h2 className="text-xl font-bold text-white mb-4">Kontakt</h2>
            <p className="text-muted-foreground">
              Bei Fragen zum Datenschutz oder zur Ausübung Ihrer Rechte kontaktieren Sie uns bitte:
            </p>
            <div className="bg-zinc-800/50 rounded-lg p-4 mt-4 text-sm">
              <p className="text-muted-foreground">
                E-Mail: <a href="mailto:support@tradejourn.ai" className="text-primary hover:underline">support@tradejourn.ai</a><br />
                Webseite: <a href="https://tradejourn.ai" className="text-primary hover:underline">www.tradejourn.ai</a>
              </p>
            </div>
          </section>
        </div>

        {/* Back to top */}
        <div className="mt-12 text-center">
          <Link to="/">
            <Button variant="outline">
              <ArrowLeft className="h-4 w-4 mr-2" />
              Zurück zur Startseite
            </Button>
          </Link>
        </div>
      </div>

      {/* Footer */}
      <footer className="border-t border-border py-8 mt-12">
        <div className="container mx-auto px-4 text-center text-sm text-muted-foreground">
          <p>© 2026 TradeJourn.ai. Alle Rechte vorbehalten.</p>
        </div>
      </footer>
    </div>
  );
};

export default DatenschutzPage;
